module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/death-benefits-6b6cbf73c4cedc7844362f22abe58f54.png";